$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Placeholder scripts
  $('.searchBoxInput input').attr('placeholder', 'Search')
  $('.searchBoxInput input').val('')
  $('#mobileSearchInput').attr('placeholder', 'Search Website')
  $('#mobileSearchInput').val('')

  // TOGGLE
  $('.mobile-nav-toggle').append(`
    <div></div>
    <div></div>
    <div></div>
    `)

  // Tickets & Deals
  $('.ticket').text("Tickets")

  $('.footer-navigation ').each(function () {
    $(this).find('.footer-navigation__separator').text('-')
  })



  // AOS > Animated on scroll for Fashion Rabbit
  $('.map-container .left-container .anim-rabbit').addClass('aos-init').attr({
    "data-aos": "fade-up",
    "data-aos-easing": "ease-in-out",
    // "data-aos-duration": "650",
    "data-aos-duration": "200",
    "data-aos-delay": "100",
    "data-aos-once": "true",
    "data-aos-offset": "200",
  })


  // Abstract shape token for inner pages
  $('.dynamicPageContainer .sectionHeading').each(function () {
    const text = $(this).text();
    if (text === '{picture-border}') {
      $(this).parent('.entityContainerRow').addClass('customImage');
      $(this).css('display', 'none')
    }
  })

  let ticketUrl = $('.ticket').attr('href');
  $(`<div><a class="ticket" href="${ticketUrl}">Tickets</a></div>`).prependTo('.mobile-menu-header')
  $('.header-logo').clone().prependTo('.mobile-menu-header')


  $('.entityContainerRow .FeatureLineupModule ').each(function(){
    $(this).parent().addClass('specialBg')
  })

});


// Weather Script
$(window).load(function () {
  setInterval(function () {
    var str = $('#weatherBugDescription').text();
    var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return
    $('#weatherBugWidget').addClass('weatherBugSet');
    var findSpace = str.lastIndexOf(' ');
    var stringLength = str.length;
    var res = str.substring(findSpace, stringLength);
    var start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('visibility', 'visible');
  }, 12);

});

